import { down } from "styled-breakpoints";
import { Modal as M } from "antd";
import styled from "styled-components";
import { Body, Button, FormItem, Title } from "sunday-component";
import { color } from "src/styles/globals";

export const CardDetail = styled.div`
  display: grid;
  gap: 24px;
`;

export const UserButton = styled(Button)`
  width: 100%;
  div {
    font-size: 21px;
    line-height: 24px;
  }
`;
export const SignupPageItem = styled(FormItem)`
  margin: 0 0 16px !important;
`;
export const SuccessModal = styled(M)<{ bodyRadius?: string }>`
  top: 0;
  margin: 0px;
  padding: 0px;
  max-width: 100vw;
  .ant-modal-header {
    border-radius: 16px 16px 0px 0px;
  }

  .ant-modal-body {
    border-radius: ${(props) => props.bodyRadius};
    padding: 0px;
    overflow: auto;
  }
  .ant-modal-footer {
    padding: 16px;
  }
  .ant-modal-content {
    border-radius: 16px;
  }
  .ant-scrolling-effect {
    width: 0px;
  }
`;

export const RegisterModal = styled(SuccessModal)`
  ${down("xs")} {
    .ant-modal,
    .ant-modal-content {
      height: 100vh;
      max-width: 100vw;
      margin: 0px;
      top: 0;
      padding: 0px;
    }
    .ant-modal-body {
      border-radius: 0;
      height: calc(100vh - 173px);
      width: 100vw;
    }
    .ant-modal-footer {
      padding: 16px 16px 32px 16px;
      position: fixed;
      bottom: 0;
      width: 100%;
      background: white;
    }
    .ant-modal-content {
      overflow: auto;
      border-radius: 0px;
    }
  }
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RegisterModalContent = styled(ModalContent)`
  padding-bottom: 0;
`;

export const SubTitleText = styled(Body).attrs({ level: 7 })`
  color: ${color.charcoal09};
  font-weight: 300;
`;

export const ExtraText = styled(Body).attrs({ level: 7 })`
  color: ${color.charcoal08};
  font-weight: 300;
`;

export const ConsentText = styled(Body).attrs({ level: 7 })`
  font-weight: 300;
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

export const BannerImg = styled.img`
  width: 100%;
  height: auto;
`;

export const CenterTitle = styled(Title).attrs({ level: 5 })`
  text-align: center;
`;

export const NextStepContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NextStepText = styled(Body).attrs({ level: 7 })`
  font-weight: 300;
  color: ${color.charcoal10};
`;

export const NextStepList = styled.ol`
  margin: 0;
`;
export const NextStepItemText = styled(Body).attrs({ level: 7 })`
  font-weight: 300;
  color: ${color.charcoal09};
`;

export const CloseDialogTitle = styled.div`
  margin: 0 -8px;
`;

export const RegisterButton = styled(Button)`
  min-width: 194px;
  ${down("sm")} {
    width: 100%;
  }
`;

export const RegisterLabel = styled(Title).attrs({ level: 7 })``;

export const Container = styled.div`
  padding: 0 24px;
`;
